import React from 'react';
import { formatDate, prettyPrintMsTime } from '../../util';
import './styles.scss';

type SessionActivity = {
  activityName: string;
  score: number
  playTime: number
  timestamp: Date
}

type SessionActivitiesTableProps = {
  activities: SessionActivity[];
};

const SessionActivitiesTable = ({ activities }: SessionActivitiesTableProps) => (
  <div className="session-activities-table-wrapper">
    <table className="session-activities-table">
      <thead>
      <tr>
        <th>Activity</th>
        <th>Score</th>
        <th>Playtime</th>
        <th>Timestamp</th>
        <th>Difficulty</th>
        <th>Device Type</th>
        <th>App Version</th>
        <th>App Name</th>
      </tr>
      </thead>

      <tbody>
      {
        activities.map((activity, index) => (
          <tr key={index}>
            <td>{activity?.activityName}</td>
            <td>{activity?.score}</td>
            <td>{prettyPrintMsTime(activity?.playTime * 1000)}</td>
            <td>{formatDate(activity?.timestamp, null, true)}</td>
            <td>{activity?.difficulty}</td>
            <td>{activity?.deviceType}</td>
            <td>{activity?.appVersion}</td>
            <td>{activity?.appName}</td>
          </tr>
        ))
      }
      </tbody>
    </table>
  </div>
);

export default SessionActivitiesTable;
